import { PLUGIN_IS_EE_BUILD } from "metabase/plugins";

export const isEEBuild = () => PLUGIN_IS_EE_BUILD.isEEBuild();
